import React, {useContext} from 'react'
import { DarkModeContext } from '../../../global/Theme'
import './index.css'


export default function ButtonWhite({text}) {
    const { isDark } = useContext(DarkModeContext);

    return (
        <div className={`button-white ${isDark ? 'dark': ''}`}>
            {text}
        </div>
    )
}
